module.exports = __webpack_public_path__ + "img/logo1.ac9dcf15.png";